import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  formItem: {
    margin: 0,
    height: 22,

    '.ant-form-item-control-input': {
      minHeight: 0
    }
  },

  description: {
    width: 400
  },

  divider: {
    margin: 0
  },

  buttonEdit: {
    marginRight: 24,
    marginBlock: 4
  },

  actions: {
    cursor: 'default'
  }
}))
